module.exports = __webpack_public_path__ + "static/media/warning.c9ba2825.png";